import getParameterFromURL from "../utils/getParameterFromUrl"
import store from './../store'

let firstQuestionA = (getParameterFromURL("firstQuestionA") === "true")
let firstQuestionB = (getParameterFromURL("firstQuestionB") === "true")
let firstQuestionC = (getParameterFromURL("firstQuestionC") === "true")
let firstQuestionD = (getParameterFromURL("firstQuestionD") === "true")
let withMail = (getParameterFromURL("withMail") === "true")
let isAgeAbtest = store.getState().appState.isAgeAbtest;
let isExtraSteps = store.getState().appState.isExtraSteps;
let forGender = store.getState().appState.forGender;
let isAgeManTest = store.getState().appState.isAgeManTest;
let stepsResult;

let firstQuestionType = firstQuestionA || firstQuestionB || firstQuestionC || firstQuestionD;

if (firstQuestionA) {

  stepsResult = {
    firstPageQuestionA: 0,
    result: 1,
    currentActivity: 2,
    old: 3,
    height: 4,
    currentWeight: 5,
    goalWeight: 6,
    dietType: 7,
    fitnesLevel: 8,
    bodyZone: 9,
    help: 10,
    workHard: 11,
    workTime: 12,
  }

} else if (firstQuestionB) {

  stepsResult = {
    firstPageQuestionB: 0,
    currentActivity: 1,
    old: 2,
    height: 3,
    currentWeight: 4,
    goalWeight: 5,
    dietType: 6,
    fitnesLevel: 7,
    bodyZone: 8,
    help: 9,
    workHard: 10,
    workTime: 11,
  }

} else if (firstQuestionC) {
  
  stepsResult = {
    firstPageQuestionC: 0,
    old: 1,
    result: 2,
    currentActivity: 3,
    height: 4,
    currentWeight: 5,
    goalWeight: 6,
    dietType: 7,
    fitnesLevel: 8,
    bodyZone: 9,
    help: 10,
    workHard: 11,
    workTime: 12,
  }

} else if (firstQuestionD) {
  
  stepsResult = {
    firstPageQuestionD: 0,
    old: 1,
    result: 2,
    currentActivity: 3,
    height: 4,
    currentWeight: 5,
    goalWeight: 6,
    dietType: 7,
    fitnesLevel: 8,
    bodyZone: 9,
    help: 10,
    workHard: 11,
    workTime: 12,
  }

} else {
  if (isAgeAbtest || isAgeManTest) {
    stepsResult = {
      old: 0,
      result: 1,
      currentActivity: 2,
      height: 3,
      currentWeight: 4,
      goalWeight: 5,
      dietType: 6,
      fitnesLevel: 7,
      bodyZone: 8,
      help: 9,
      workHard: 10,
      workTime: 11,
    }
  } else {
    stepsResult = {
      sex: 0,
      result: 1,
      currentActivity: 2,
      old: 3,
      height: 4,
      currentWeight: 5,
      goalWeight: 6,
      dietType: 7,
      fitnesLevel: 8,
      bodyZone: 9,
      help: 10,
      workHard: 11,
      workTime: 12,
    }
  }
}

if (isExtraSteps && !firstQuestionType) {
  if (forGender === 'female') {
    stepsResult = {
      old: 0,
      result: 1,
      currentActivity: 2,
      height: 3,
      currentWeight: 4,
      goalWeight: 5,
      dietType: 6,
      fitnesLevel: 7,
      bodyZone: 8,
      help: 9,
      workHard: 10,
      workTime: 11,
    };
  }

  if (forGender === 'male') {
    stepsResult = {
      old: 0,
      // sex: 0,
      result: 1,
      currentActivity: 2,
      height: 3,
      currentWeight: 4,
      goalWeight: 5,
      dietType: 6,
      fitnesLevel: 7,
      bodyZone: 8,
      help: 9,
      workHard: 10,
      workTime: 11,
    };
  }
}

let extraSteps = [
  'sleep',
  'water',
  'motivation',
  'lifeChange',
  'idealWeight',
];

if (isExtraSteps) {
  let totalSteps = Object.keys(stepsResult).length;

  extraSteps.forEach((step, index) => {
    stepsResult[step] = totalSteps + index;
  });
}

if (withMail) {
  stepsResult['mail'] = Object.keys(stepsResult).length;
}

export let steps = stepsResult;